import {createImgIn} from '../ui_utils/DomUtils.ts'
import {ViewPopup} from './ViewPopup.ts'
import {LobbyImage} from '@colonist/types'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'
import {StorageWrapper} from '../StorageWrapper.ts'
import {ClientPlatformRedirection} from '../ClientPlatformRedirection.ts'

export class UISwitchToPortraitPopup extends ViewPopup {
    constructor(xAction: () => void) {
        super({key: 'strings:popups.switchToPortrait.title'},
            {key: 'strings:popups.switchToPortrait.description', options: {date: UIUtilsEjsVariables.portraitModeEnforcementDate}},
            () => {
                StorageWrapper.setPortraitModeEnforcementAccepted(true)
                ClientPlatformRedirection.handleRedirectNewAccountsToMobileWeb()
            },
            xAction,
            false, {
                checkButtonCustomContent: {key: 'strings:popups.switchToPortrait.okButton'},
                xButtonCustomContent: {key: 'strings:popups.switchToPortrait.cancelButton'},
            })
        this.xButton.style.backgroundColor = 'rgba(0, 0, 0, 0.2)'
        const img = createImgIn(this.body, LobbyImage.SwitchToPortrait, '')
        this.body.prepend(img)
    }
}
